exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".landing-loader{\n    position: absolute;\n    width: 100%;\n    height: 100vh;\n    vertical-align: middle;\n    background: #090e28;\n}\n.landing-loader > img {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 50%;\n}", ""]);

// exports
